/* Publish by EComposer at 2024-06-25 15:09:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8ix1n2phlhy"]=  window.__ectimmers["ecom-8ix1n2phlhy"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8ix1n2phlhy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ix1n2phlhy', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oq1y8synz7"]=  window.__ectimmers["ecom-oq1y8synz7"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-oq1y8synz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oq1y8synz7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zvsdolur0x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zvsdolur0x', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-srp97l59iee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-srp97l59iee', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdpdlh6bd4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdpdlh6bd4p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gj1eng5j08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gj1eng5j08', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0g6nwpicb56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g6nwpicb56', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jqpo99wmm3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqpo99wmm3s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yln533tqmzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yln533tqmzm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zksm2uqxp09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zksm2uqxp09', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d510i96147e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d510i96147e', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3lyc4mfwr7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3lyc4mfwr7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilmpv2hgba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilmpv2hgba', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}